import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { StateProps } from '../../redux/reducer';
import { sidebarLayoutChange, updateSidebarTab } from '../../redux/action';
import user from '../../assets/default.jpg';
import { colors } from '../../config/constants';
import { adminMenu, superAdminMenu, userMenu } from '../../config/sidebarItems';
import instance from '../../service/axiosInstane';
import { flashBarTheme } from '../../config/flashBar';
import { Role } from '../../config/enum';
import { apiUrl } from '../../config/constants';
import {
  categoryRoute,
  crawlJobRoute,
  dashboardRoute,
  noisewordRoute,
  organizationRoute,
  rolesRoute,
  serverRoute,
  userRoute,
  websiteRoute,
  dmcaFilesRoute,
  manualSearchRoute,
  reportsRoute,
  hitCountJobRoute,
} from '../../config/sidebarRouting';

type MenuItemProps = {
  name: string;
  url: string;
  icon: JSX.Element;
};

const Sidebar = () => {
  const dispatch = useDispatch();
  const activeTab = useSelector((state: StateProps) => state.defaultSideBarTab);
  const sidebarLayout = useSelector((state: StateProps) => state.sidebarLayout);
  const userInfo = useSelector((state: StateProps) => state.tokenInfo.userInfo);
  const [showToolTip, setShowToolTip] = useState(false);
  const { role, firstName, profileImage } = userInfo;
  const [activeRole, setActiveRole] = useState<MenuItemProps[] | null>(null);
  const [showSuggetion, setShowSuggetion] = useState(false);
  const [indexing, setIndexing] = useState<any>(null);

  const [flashbar, setFlashbar] = useState({
    isOpen: false,
    message: '',
    type: '',
  });
  const [appInfo, setAppInfo] = useState({
    version: '',
    environment: '',
  });

  useEffect(() => {
    if (role === Role.SuperAdmin) {
      setActiveRole(superAdminMenu);
    } else if (role === Role.Admin) {
      setActiveRole(adminMenu);
    } else {
      setActiveRole(userMenu);
    }
    getInfo();
  }, []);

  useEffect(() => {
    updatingSidebar();
  }, [window.location.href]);

  const updatingSidebar = () => {
    const currentLoc = window.location.href.split('/');
    if (currentLoc.some((item) => dashboardRoute.includes(item))) {
      dispatch(updateSidebarTab('Dashboard'));
    } else if (currentLoc.some((item) => rolesRoute.includes(item))) {
      dispatch(updateSidebarTab('Roles'));
    } else if (currentLoc.some((item) => userRoute.includes(item))) {
      dispatch(updateSidebarTab('Users'));
    } else if (currentLoc.some((item) => websiteRoute.includes(item))) {
      dispatch(updateSidebarTab('Websites'));
    } else if (currentLoc.some((item) => categoryRoute.includes(item))) {
      dispatch(updateSidebarTab('Categories'));
    } else if (currentLoc.some((item) => noisewordRoute.includes(item))) {
      dispatch(updateSidebarTab('Noise Words'));
    } else if (currentLoc.some((item) => serverRoute.includes(item))) {
      dispatch(updateSidebarTab('Server'));
    } else if (currentLoc.some((item) => organizationRoute.includes(item))) {
      dispatch(updateSidebarTab('Organization'));
    } else if (currentLoc.some((item) => crawlJobRoute.includes(item))) {
      dispatch(updateSidebarTab('Crawl Jobs'));
    } else if (currentLoc.some((item) => dmcaFilesRoute.includes(item))) {
      dispatch(updateSidebarTab('DMCA Files'));
    } else if (currentLoc.some((item) => manualSearchRoute.includes(item))) {
      dispatch(updateSidebarTab('Manual Search'));
    } else if (currentLoc.some((item) => reportsRoute.includes(item))) {
      dispatch(updateSidebarTab('Reports'));
    } else if (currentLoc.some((item) => hitCountJobRoute.includes(item))) {
      dispatch(updateSidebarTab('Hit Count Jobs'));
    } else {
      dispatch(updateSidebarTab(''));
    }
  };

  const handleOnclick = (item: string) => {
    dispatch(updateSidebarTab(item));
  };

  const getInfo = async () => {
    await instance
      .get(`/app/info`)
      .then((response) => {
        if (response.status === 200) {
          setAppInfo(response.data);
        }
      })
      .catch((err) => {
        setFlashbar({
          ...flashbar,
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        });
      });
  };

  return (
    <div className="bg-white rounded-sm">
      <div
        className={`hidden relative sm:block ${
          sidebarLayout ? 'w-48' : 'w-16'
        } shadow-sm px-2 min-h-screen mb-2 py-1 transition-all duration-200 ease-in-out`}
      >
        <div
          className={`flex ${colors.primary} items-center ${
            !sidebarLayout && 'justify-center'
          }  text-[white] shadow-sm border rounded-sm`}
        >
          <div className="p-2">
            <img
              className={`rounded-full border-2 my-1 ${
                sidebarLayout ? 'w-12 h-12' : 'h-8 w-8'
              }`}
              src={profileImage ? `${apiUrl}/${profileImage}` : user}
            />
          </div>
          {sidebarLayout && (
            <div onMouseLeave={() => setShowToolTip(false)}>
              <div className="text-sm">Welcome</div>
              <div
                onMouseOver={() => setShowToolTip(true)}
                className="font-bold pb-2 uppercase cursor-pointer"
              >
                {firstName.length < 10
                  ? firstName
                  : firstName.substring(0, 8) + '...'}
                {showToolTip && firstName.length > 10 && (
                  <div className="absolute w-full bg-white rounded p-2 text-sm font-medium text-[#27374d]">
                    {firstName}
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
        <div>
          {activeRole?.map((item: MenuItemProps, index: number) => {
            return (
              <Link
                onMouseLeave={() => setShowSuggetion(false)}
                onMouseOver={() => {
                  setShowSuggetion(true);
                  setIndexing(item.name);
                }}
                to={item.url}
                onClick={() => handleOnclick(item.name)}
                key={index}
                className={`relative z-2 ${
                  activeTab === item.name
                    ? `text-white bg-[#50a0d9] font-semibold shadow-sm group  `
                    : 'text-[gray] '
                }  hover:text-white hover:bg-[#50a0d9]  flex items-center ${
                  sidebarLayout ? 'p-1 rounded-sm' : 'p-2 rounded-sm '
                } my-2 cursor-pointer shadow-sm`}
              >
                <div
                  className={` ${
                    sidebarLayout
                      ? 'text-md w-7 ml-1'
                      : 'text-xl flex justify-center items-center w-full  '
                  } `}
                >
                  {' '}
                  {item.icon}
                </div>

                {sidebarLayout ? <div className="text-sm">{item.name}</div> : ''}
                {!sidebarLayout && (
                  <div className="absolute top-9 left-10 text-sm z-50 ">
                    {item.name === indexing && showSuggetion && (
                      <div className="bg-blue-950 px-2 py-1 text-white rounded-sm whitespace-nowrap opacity-80">
                        {item.name}
                      </div>
                    )}
                  </div>
                )}
              </Link>
            );
          })}
        </div>
        <div
          onClick={() => dispatch(sidebarLayoutChange(!sidebarLayout))}
          className={`absolute bottom-16 p-2 ${
            sidebarLayout ? 'right-4' : 'left-0 w-full'
          } flex justify-center items-center text-[gray] cursor-pointer`}
        >
          <i
            className={`fa-solid ${
              sidebarLayout ? 'fa-angles-left' : 'fa-angles-right'
            } text-[20px]`}
          ></i>
        </div>
        {userInfo.role === Role.SuperAdmin && (
          <div
            className={`text-sm text-[#27374d] absolute p-2 bg-[#dbeafe] border rounded ${
              sidebarLayout ? 'bottom-[110px] right-[34px]' : 'hidden'
            }`}
          >
            <div className="capitalize flex">
              <div className="w-[33px]">v</div>
              <div>: {appInfo.version}</div>
            </div>
            <div className="flex">
              <div className="w-[33px]">Env</div>
              <div className="uppercase">: {appInfo.environment}</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Sidebar;
